import { api } from "api";
import type { NonIndexRouteObject } from "react-router-dom";

import LiquidatorWhitelistRoute from "./LiquidatorWhitelistRoute";

export const liquidatorRoute: NonIndexRouteObject = {
  loader: () => api.listWhitelist("liquidator"),
  element: <LiquidatorWhitelistRoute />,
};
